import { render, staticRenderFns } from "./DZSVG.vue?vue&type=template&id=25be75a6&scoped=true"
import script from "./DZSVG.vue?vue&type=script&lang=js"
export * from "./DZSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be75a6",
  null
  
)

export default component.exports